import React from 'react';
import { IconButton, Typography } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import CheckIcon from '@mui/icons-material/Check';

/* eslint-disable import/prefer-default-export */
const TitleStyle = {
  fontSize: '12px',
  fontWeight: 500,
  borderBottom: 'none',
  textTransform: 'uppercase',
  background: '#e4e7ea',
  font: 'normal normal 600 10px Montserrat',
  letterSpacing: 0,
  color: '#707070',
  padding: '16px 8px',
};
const defaultColumnStyle = {
  font: 'normal normal 600 14px Montserrat',
  letterSpacing: 0,
  color: '#38485C',
  marginLeft: 5,
};
export const columns = [
  {
    id: 'reference',
    label: 'Réf',
    style: TitleStyle,
    render: ({ value }) => (
      <Typography sx={{ color: '#333D66', fontSize: '16px', fontWeight: 500 }}>{value}</Typography>
    ),
  },
  {
    id: 'des',
    label: 'Désignation',
    style: TitleStyle,
    render: ({ value }) => <Typography sx={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'action',
    label: '',
    style: TitleStyle,
    render: ({ row }) => (
      <IconButton
        onClick={() => row.handleSelectProduct(row.reference)}
        style={{
          background: row.selected ? '#00B894' : '#007BC6',
          borderRadius: 12,
          padding: 8,
          color: '#FFF',
        }}
        size="large"
      >
        {row.selected ? <CheckIcon /> : <LinkIcon />}
      </IconButton>
    ),
  },
];

/*

      <Radio
        checked={row.selected}
        onChange={}
        value={row.reference}
        name="related-product"
      />
*/
